import {
  UPDATE_MANAGER_FORM,
  RESET_MANAGER_FORM,
} from "../actions/ManagerForm.action";

const today = new Date();
today.setHours(12, 0, 0, 0);

const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
firstDayOfMonth.setHours(12, 0, 0, 0);

const initialState = {
  start_date: firstDayOfMonth,
  end_date: today,
  client_id: "",
  program_id: "",
  region_ids: [],
};

const ManagerFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MANAGER_FORM:
      return { ...state, ...action.payload };

    case RESET_MANAGER_FORM:
      return { ...initialState };

    default:
      return state;
  }
};

export default ManagerFormReducer;
